import {
  SET_LEAVES
} from '../actions/types';

const initialState = {
  all: []
}

export function leave(state = initialState, action = {}) {
  switch (action.type) {
    case SET_LEAVES:
      const leaves = action.leaves.map(le => {
        if (le.entries.constructor === Array) {
          le.entries = {};
        }
        return le;
      });
      return Object.assign({}, state, { all: leaves });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/leave.js